import { render } from "./Fibonacci.vue?vue&type=template&id=0ea1f6b4&scoped=true&ts=true"
import script from "./Fibonacci.vue?vue&type=script&lang=ts"
export * from "./Fibonacci.vue?vue&type=script&lang=ts"

import "./Fibonacci.vue?vue&type=style&index=0&id=0ea1f6b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea1f6b4"]])

export default __exports__